import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DebtServicePaymentFormView } from '../../models/debt-management/DebtServicePaymentFormView';
import { UtilityService } from '../utility.service';
import { FormSearch } from 'app/models/dashboard/FormStatus';
import { BaseDashboard } from 'app/models/dashboard/BaseDashboard';

@Injectable({
	providedIn: 'root',
})
export class DebtServicePaymentService {
	private readonly urlPath = `${environment.apiUrl}debt-management/clients/`;
	private readonly headers = new HttpHeaders({
		'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
	});

	constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		const url = `${
			this.urlPath
		}${clientId}/forms/debt-service-payment-form/users/${userId}?${this.utilityService.objectToQueryString(search)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	getForm(clientId: string, id: string): Observable<DebtServicePaymentFormView> {
		return this.httpClient.get<DebtServicePaymentFormView>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form/${id}`,
			{ headers: this.headers }
		);
	}

	getAllForms(clientId: string): Observable<DebtServicePaymentFormView[]> {
		return this.httpClient.get<DebtServicePaymentFormView[]>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form`
		);
	}

	createForm(clientId: string, request: DebtServicePaymentFormView): Observable<DebtServicePaymentFormView> {
		return this.httpClient.post<DebtServicePaymentFormView>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form`,
			request
		);
	}

	updateForm(
		clientId: string,
		id: string,
		request: DebtServicePaymentFormView
	): Observable<DebtServicePaymentFormView> {
		return this.httpClient.put<DebtServicePaymentFormView>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form/${id}`,
			request
		);
	}

	submitForApproval(clientId: string, id: string): Observable<DebtServicePaymentFormView> {
		return this.httpClient.post<DebtServicePaymentFormView>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form/${id}/approval`,
			{}
		);
	}

	sendForReview(clientId: string, id: string): Observable<DebtServicePaymentFormView> {
		return this.httpClient.post<DebtServicePaymentFormView>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form/${id}/review`,
			{}
		);
	}

	rejectForm(
		clientId: string,
		id: string,
		rejection: { reason: string; workflowId: number }
	): Observable<DebtServicePaymentFormView> {
		return this.httpClient.post<DebtServicePaymentFormView>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form/${id}/decline`,
			rejection
		);
	}

	approveForm(clientId: string, id: string, userId: string): Observable<DebtServicePaymentFormView> {
		return this.httpClient.post<DebtServicePaymentFormView>(
			`${this.urlPath}${clientId}/forms/debt-service-payment-form/${id}/approve`,
			{ userId }
		);
	}
}
